import {
  completeQueryResult,
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';
import { filter, map, pipe, switchMap } from 'rxjs';

import { Injectable } from '@angular/core';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { MineOrganizationsGQL } from 'ZalamoLibrary/src/lib/core/organizations/organization-member/graphql';

@Injectable({
  providedIn: 'root',
})
export class OrganizationDetailsService {
  isSolo$ = this.organizationService.getCurrentOrganization().pipe(
    switchMap((organizationId) =>
      this.mineOrganizationsGQL.watch({}).valueChanges.pipe(
        throwOnQueryError,
        filter(hasCompleteQueryData),
        map((result) => result.data['mineOrganizations']),
        map(
          (organizations) =>
            organizations.find(
              (organization) => organization.organizationId === organizationId,
            )?.isSolo,
        ),
      ),
    ),
  );

  flags$ = this.organizationService.getCurrentOrganization().pipe(
    switchMap((organizationId) =>
      this.mineOrganizationsGQL.watch({}).valueChanges.pipe(
        throwOnQueryError,
        filter(hasCompleteQueryData),
        map((apolloQueryResult) => {
          const {
            data: { mineOrganizations },
          } = completeQueryResult(apolloQueryResult);
          return mineOrganizations.find(
            (organization) => organization.organizationId === organizationId,
          )?.flags;
        }),
      ),
    ),
  );
  constructor(
    private organizationService: OrganizationService,
    private mineOrganizationsGQL: MineOrganizationsGQL,
  ) {}

  isSolo() {
    return this.isSolo$;
  }
}
